// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import {
    call,
    put,
} from 'redux-saga/effects';

import {
    PUT_PART_INFO,
    putPartInfoSuccess,
    putPartInfoFail,
} from './../../../store/orderCreation';

import {
    actionStatusStarted,
    actionStatusFailed,
    actionStatusSuccess,
} from './../../../store/actionStatus';

import DeviceDal from './../../../dal/DeviceDal';

export function* putPartInfo(request: any): IterableIterator<any> {
    const {
        deviceSerial,
        partSerial,
    } = request.payload;
    
    try {
        yield put(actionStatusStarted({actionName: `${PUT_PART_INFO}-${deviceSerial}`}));

        const partInfo = yield call(
            DeviceDal.putDevice,
            partSerial
        );

        yield put(actionStatusSuccess({actionName: `${PUT_PART_INFO}-${deviceSerial}`}));
        yield put(putPartInfoSuccess({
            deviceSerial,
            partSerial,
            data: partInfo,
        }));
    } catch (e) {
        yield put(actionStatusFailed({
            actionName: `${PUT_PART_INFO}-${deviceSerial}`,
            data: {
                deviceSerial,
                partSerial,
            },
            error: e,
        }));
        yield put(putPartInfoFail({
            deviceSerial,
            partSerial,
        }));
    }
}
